module.exports = __webpack_public_path__ + "img/ic_apple_original.52b2659b.svg";